export const NavData = [
  { activeTab: 1, iconName: "fa-user", tittle: "Company info" },
  { activeTab: 2, iconName: "fa-chain-broken", tittle: "Account Credentials" },
  { activeTab: 3, iconName: "fa-group", tittle: "Server Credentials" },
  { activeTab: 4, iconName: "fa-chain-broken", tittle: "Permissions" },
  { activeTab: 5, iconName: "fa-group", tittle: "Attachements" },
  { activeTab: 6, iconName: "fa-group", tittle: "Preview" },
];
